import { useCallback, useEffect, useState } from "react";
import { temaDoErp } from "../lib/sso";

export type Theme = "light" | "dark";

const STORAGE_KEY = "formsteel-theme";

function getInitial(): Theme {
  // Embutido no ERP: manda o tema do ERP (o salvo no Painel e o do sistema operacional são ignorados).
  const erp = temaDoErp();
  if (erp) return erp;
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "dark" || stored === "light") return stored;
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(getInitial);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    if (!temaDoErp()) localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  useEffect(() => {
    const k = (e: Event) => setTheme((e as CustomEvent<Theme>).detail);
    window.addEventListener("formsteel-tema", k);
    return () => window.removeEventListener("formsteel-tema", k);
  }, []);

  const toggle = useCallback(() => {
    setTheme((t) => (t === "light" ? "dark" : "light"));
  }, []);

  return { theme, toggle };
}
